import BranchMapHome from 'pages/branchMap/BranchMapHome';
import BuyingMapHome from 'pages/buyingMap/BuyingMapHome';
import OfferTransferChartPage from 'pages/chart/OfferTransferChartPage';
import OwnerCertificationChartPage from 'pages/chart/OwnerCertificationChartPage';
import QuoteChartPage from 'pages/chart/QuoteChartPage';
import ComplexStandardPriceMapHome from 'pages/complexStandardPriceMap/ComplexStandardPriceMapHome';
import GapMapHome from 'pages/gapMap/GapMapHome';
import LikeComplexMapHome from 'pages/likeComplexMap/LikeComplexMapHome';
import NormalMapHome from 'pages/normalMap/NormalMapHome';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { useLocation } from 'react-router';
import {
  Redirect,
  Route,
  BrowserRouter as Router,
  Switch,
} from 'react-router-dom';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import rootSaga from 'redux/sagas/rootSaga';
import rootReducer from 'redux/store/rootReducer';
import GlobalStyle from 'styles/GlobalStyle';
import 'styles/fonts/fonts.css';

const sagaMiddleware = createSagaMiddleware();

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(sagaMiddleware)),
);

sagaMiddleware.run(rootSaga);

interface RouteProps {
  path: string;
  component: () => JSX.Element;
}

const routes: RouteProps[] = [
  {
    path: '/gap',
    component: GapMapHome,
  },
  {
    path: '/normal',
    component: NormalMapHome,
  },
  {
    path: '/branch',
    component: BranchMapHome,
  },
  {
    path: '/buying',
    component: BuyingMapHome,
  },
  {
    path: '/chart/quote',
    component: QuoteChartPage,
  },
  {
    path: '/chart/certification',
    component: OwnerCertificationChartPage,
  },
  {
    path: '/chart/offer-transfer',
    component: OfferTransferChartPage,
  },
  {
    path: '/complex-standard-price',
    component: ComplexStandardPriceMapHome,
  },
  {
    path: '/like/complex', // 갈아타기 찜단지 맵표기
    component: LikeComplexMapHome,
  },
];

function App() {
  const location = useLocation();

  return (
    <Switch location={location}>
      <Route exact path="/" render={() => <Redirect to="/normal" />} />
      {routes.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          component={route.component}
          exact
        />
      ))}
    </Switch>
  );
}

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <GlobalStyle />
      <App />
    </Router>
  </Provider>,
  document.getElementById('root'),
);
